import { render } from "./App.vue?vue&type=template&id=ada7267e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ada7267e&lang=css"
script.render = render
/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(script)


export default script